/**
 * LeaderTypeService
 * Service for managing the leader type catalog
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for leader type catalog CRUD operations
 */
export class LeaderTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? LeaderTypeService.DEFAULT_SERVICE_PATH,
            basePath: LeaderTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
LeaderTypeService.DEFAULT_SERVICE_PATH = 'ac-counselling';
LeaderTypeService.BASE_PATH = 'api/leader-types';
//# sourceMappingURL=LeaderTypeService.js.map